
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class MaterialReceiptSelectGrid extends _Ext.GridBase<MaterialReceiptItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.MaterialReceiptItems'; }
        protected getDialogType() { return <any>MaterialReceiptItemsDialog; }
        protected getIdProperty() { return MaterialReceiptItemsRow.idProperty; }
        protected getLocalTextPrefix() { return MaterialReceiptItemsRow.localTextPrefix; }
        protected getService() { return Inventory.MaterialReceiptSelectItemsService.baseUrl; }

        //protected useViewMode() { return true; } 
        //static items = [];
   
        constructor(container: JQuery, options: any) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            var partyid = options.GridFilters.PartyId;
            (this.view.params as TransactionRequest).PartyId = partyid;
            return this;
        }

        private autoSize; 

        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): MaterialReceiptItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}